import React from 'react';

const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M2.93,17.07a10,10,0,1,1,14.14,0A10,10,0,0,1,2.93,17.07Zm1.15-1.18a8.35,8.35,0,1,0,0-11.81A8.37,8.37,0,0,0,4.08,15.89Z" />
    <path d="M10,5.23a.81.81,0,0,0-.82.82V9.18H6.05a.82.82,0,0,0,0,1.64H9.18V14a.81.81,0,0,0,.82.82.87.87,0,0,0,.58-.24.85.85,0,0,0,.24-.58V10.82H14a.85.85,0,0,0,.58-.24.87.87,0,0,0,.24-.58A.81.81,0,0,0,14,9.18H10.82V6.05A.81.81,0,0,0,10,5.23Z" />
  </svg>
);

export default AddIcon;
